import AppForm from '../app-components/Form/AppForm';
import FormMixin from './formMixin';

Vue.component('app-payment-form', {
    mixins: [AppForm, FormMixin],
    props: {
        selectedFarmerDriver: {
            type: Object,
            default: ()=>{}
        },
        selectedFactory: {
            type: Object,
            default: ()=>{}
        },
        selectedField: {
            type: Object,
            default: ()=>{}
        },
        selectedPriceFactory: {
            type: Object,
            default: ()=>{}
        },
        listPriceFactory: {
            type: Array,
            default: ()=>[]
        },
        logs: {
            type: Array,
            default: ()=>[]
        },
        histories: {
            type: Array,
            default: ()=>[]
        },
        oldFinances: {
            type: Object,
            default: ()=>{  }
        },
        totalOldFinances: {
            type: Number,
            default: 0
        },
        priceExtras: {
            type: Array,
            default: ()=>[]
        },
        hasPayed: {
            type: Boolean,
            default: false
        },
        
        activePaymentGroups: {
            type: Array,
            default: ()=>[]
        },
    },
    mounted: function () {  
        this.getListFarmer()
        this.getListFields()
    },
    computed: {
        filteredListPriceFactory() {
            if (this.tempFactory==null) {
                this.tempPriceFactory = {}
                return []
            }
            const thisObjc = this
            const results = this.listPriceFactory.filter(function (x) { 
                return x.app_factories_id == thisObjc.tempFactory.parent_id
            })
            if (results.length==0) {
                this.tempPriceFactory = {}
             }
             return results;
        },
        getPreviewPriceExtras() {
            const thisObjc = this
            const results = thisObjc.priceExtras.map((d) =>d*thisObjc.form.netto )
             return results;
        },
       
    },
    methods:{
        onSubmit: function onSubmit() {
            var _this4 = this;

            return this.$validator.validateAll().then(function (result) {
                console.log('result', result)
                if (!result) {
                _this4.$notify({
                    type: 'error',
                    title: 'Error!',
                    text: 'The form contains invalid fields.'
                });
                return false;
                }

                var data = _this4.form;
                if (!_this4.sendEmptyLocales) {
                data = _.omit(_this4.form, _this4.locales.filter(function (locale) {
                    return _.isEmpty(_this4.form[locale]);
                }));
                }

                _this4.submiting = true;

                axios.post(_this4.action, _this4.getPostData()).then(function (response) {
                return _this4.onSuccess(response.data);
                }).catch(function (errors) {
                return _this4.onFail(errors.response.data);
                });
            });

        }
    },

});